<div style="width:100%;display:flex;flex-wrap:wrap;">
  <div *ngFor="let d of dataInSelectedUnits;let index=index"
    [ngClass]="pinnedSelection? 'bordered halfsize' : 'bordered fullsize'">
    <dx-chart #chart [dataSource]="d.series" [size]="size"
      [animation]="{duration: 500, easing: 'easeOutCubic', enabled: true, maxPointCountSupported: 3000 }">

      <dxo-zoom-and-pan valueAxis="both" argumentAxis="both" [dragToZoom]="true" [allowMouseWheel]="false"
        panKey="shift"></dxo-zoom-and-pan>

        <dxo-legend horizontalAlignment="center" verticalAlignment="bottom" [font]="{color:'#809DA4',size:13}">
      </dxo-legend>

      <dxo-crosshair [enabled]="true" color="#949494" [width]="3" dashStyle="dot">
        <dxo-label [visible]="true" backgroundColor="#949494">
          <dxo-font color="#fff" [size]="12">
          </dxo-font>
        </dxo-label>
      </dxo-crosshair>

      <dxo-common-pane-settings>
        <dxo-border [visible]="true"></dxo-border>
      </dxo-common-pane-settings>

      <dxo-argument-axis
        [grid]="{color:'#809DA4'}"
        [visualRange]="visualRangeX[index]"
        [type]="plotConfig[index].logX ? 'logarithmic' : 'linear'" [minorGrid]="{color:'#809DA4'}"
        [grid]="{color:'#809DA4'}"
        [minorGrid]="{color:'#809DA4'}"
        [minorTickCount]="9"
        [title]="d.argTitle + (d.argQuantity?' ('+unitsService.getSelectedUnitForQuantity(d.argQuantity)+')':'')">
        <dxo-label [format]="plotConfig[index].logX ? 'exponential' : 'decimal'" [customizeText]="customizeText">
        </dxo-label>
        <dxo-grid visible="true"></dxo-grid>
        <dxo-minor-grid [visible]="plotConfig[index].logX"></dxo-minor-grid>
      </dxo-argument-axis>

      <dxi-value-axis position="left" name="speed"
        [visualRange]="visualRangeY[index]"
        [type]="plotConfig[index].logY ? 'logarithmic' : 'linear'"
        [grid]="{color:'#809DA4'}"
        [minorGrid]="{color:'#809DA4'}"
        [minorTickCount]="9"
        [title]="d.valTitle + (d.valQuantity?' ('+unitsService.getSelectedUnitForQuantity(d.valQuantity)+')':'')">
        <dxo-grid visible="true"></dxo-grid>
        <dxo-label [format]="plotConfig[index].logY ? 'exponential' : 'decimal'" [customizeText]="customizeText">
        </dxo-label>
        <dxo-minor-grid [visible]="plotConfig[index].logY"></dxo-minor-grid>
      </dxi-value-axis>
      <dxi-series *ngFor="let p of d.plots" [argumentField]="p.arg" [valueField]="p.val" [name]="p.name">
        <dxo-point size="0"></dxo-point>
      </dxi-series>
    </dx-chart>
    <dx-button [text]="showConfig[index]?'Hide Axis Config':'Show Axis Config'"
      (onClick)="showConfig[index]=!showConfig[index]"></dx-button>
    <dx-button text="Reset Zoom" (onClick)="resetZoom(index)" style="margin-left: 10px;"></dx-button>
    <dx-button text="Export" (onClick)="export(index)" style="margin-left: 10px;"></dx-button>
    <div [ngClass]="showConfig[index]?'show':'hide'">
      <app-chart-options [plotConfig]="plotConfig[index]" (plotConfigChange)="plotConfigChange($event,index)">
      </app-chart-options>
    </div>
  </div>
</div>

